import { disputesRef, jobsRef, usersRef } from "../firebase";
import { getUserInfo } from "../storage";
import { getFirebaseDisputes, getFirebaseDisputesByDocId, getFirebaseJob } from "../utils";
import { PUT } from '../API/put';
import { GET } from '../API/get';
import { showNotification } from "../common/notifications/notifications";

const user_info = getUserInfo();

export const isOpenNotification = async (payload, dispatch, pathname = "") => {
    const { title, body } = payload?.data || {};
    const parsedBody = JSON.parse(body);

    switch (title) {
        case "NEW_DIRECT_MESSAGE":
            pathname !== "/jobs/messages" && openJobChatView(parsedBody, dispatch);
            break;
        case "NEW_DISPUTE_MESSAGE":
            pathname !== "/disputes/messages" && openDisputChatView(parsedBody, dispatch);
            break;
        case "NEW_OFFICE_MESSAGE":
            pathname !== "/office/messages" && openOfficeChatView(dispatch);
            break;
        case "FTM_REQUEST_MORE_TIME_AND_MATERIALS":
            openFtmRequestAlertView(parsedBody, dispatch);
            break;
        case "CUS_NEW_REMEDIAL_JOB":
            openRemedialJobAlertView(parsedBody.job_id, dispatch);
            break;
        case "REQUEST_RESCHEDULE_JOB":
            openRescheduleJobAlertView(parsedBody, dispatch);
            break;
        case "CUSTOMER_NEW_RECALL_JOB_VISIT":
            openReCallVisitAlertView(parsedBody?.re_call_visit_id, dispatch);
            break;
        case "REQUEST_SIGNATURE_OF_CUSTOMER":
            openRequestSignatureView(parsedBody, dispatch);
            break;
        default:
            break;
    }
};

const updateFirebaseDocument = async (ref, user_info) => {
    await ref.update({
        [`${ref.path.split('/')[0]}_last_message_seen_user`]: user_info.customer_firebase_document_id,
        [`${ref.path.split('/')[0]}_last_message_seen_timestamp`]: new Date().getTime(),
    });
};

export const openRequestSignatureView = async (job_id, dispatch) => {
    dispatch({
        type: 'SET_REQUEST_SIGNATURE_OF_CUSTOMER',
        snackbar: {
            is_show: true,
            type: 'alert',
            msg: "Tradespersons are requesting your signature."
        },
        signaturePad: {
            is_show: true,
            job_id
        }
    });
};

export const openJobChatView = async (job_id, dispatch) => {
    try {
        // isShowChatNotifications(job_id, "NEW_DIRECT_MESSAGE");
        const job_details = await getFirebaseJob(job_id);
        const documentId = job_details?.doc_id?.trim();

        if (!documentId) {
            throw new Error("Job Firebase document ID is missing.");
        }
        
        const ref = jobsRef.doc(documentId);
        
        await updateFirebaseDocument(ref, user_info);

        dispatch({
            type: 'SET_DIRECTCHAT',
            directChat: {
                is_show: true,
                job_id,
                job_firebase_document_id: documentId
            }
        });
    } catch (error) {
        showNotification({notificationType: 'OPEN_JOB_CHAT_VIEW_INVALID_JOB_ID'});
    }
};

export const openDisputChatView = async (job_id, dispatch) => {
    try {
        const dispute = await getFirebaseDisputes(job_id);
        const documentId = dispute?.doc_id?.trim();

        if (Object.keys(dispute).length > 0 && documentId) {
            const ref = disputesRef.doc(documentId);
            
            await updateFirebaseDocument(ref, user_info);

            dispatch({
                type: 'SET_DISPUTESCHAT',
                disputesChat: {
                    is_show: true,
                    dispute
                }
            });
        } else {
            showNotification({notificationType: 'OPEN_DISPUT_CHAT_NO_DISPUTE_MESSAGES_AVAILABLE'});
        }
    } catch (error) {
        showNotification({notificationType: 'OPEN_JOB_CHAT_VIEW_INVALID_JOB_ID'});
    }
};

export const openDisputChatViewByDocId = async (doc_id, dispatch) => {
    try {
        const dispute = await getFirebaseDisputesByDocId(doc_id);
        const documentId = dispute?.doc_id?.trim();

        if (Object.keys(dispute).length > 0 && documentId) {
            const ref = disputesRef.doc(documentId);
            
            await updateFirebaseDocument(ref, user_info);

            dispatch({
                type: 'SET_DISPUTESCHAT',
                disputesChat: {
                    is_show: true,
                    dispute
                }
            });
        } else {
            showNotification({notificationType: 'OPEN_DISPUT_CHAT_NO_DISPUTE_MESSAGES_AVAILABLE'});
        }
    } catch (error) {
        showNotification({notificationType: 'OPEN_JOB_CHAT_VIEW_INVALID_JOB_ID'});
    }
};

export const openOfficeChatView = async (dispatch) => {
    try {
        // isShowChatNotifications(0, "NEW_OFFICE_MESSAGE");
        const documentId = user_info?.customer_firebase_document_id?.trim();
        if (!documentId) {
            throw new Error("Customer Firebase document ID is missing.");
        }

        const ref = usersRef.doc(documentId);
        
        await updateFirebaseDocument(ref, user_info);

        dispatch({
            type: 'SET_OFFICECHAT',
            officeChat: { is_show: true }
        });
    } catch (error) {
        console.error("Error opening office chat:", error);
    }
};

export const openFtmRequestAlertView = (request, dispatch) => {
    dispatch({
        type: 'SET_SNACKBAR_AND_FTMREQUESTALERT',
        snackbar: {
            is_show: true,
            type: 'alert',
            msg: "You have a new FTM request."
        },
        ftmRequestAlert: {
            is_show: true,
            request_data: {
                job_id: request.job_id,
                request_id: parseInt(request.request_id)
            }
        }
    });
};

export const showSnackbar = (payload, dispatch) => {
    if (payload?.data?.message) {
        const msg = JSON.parse(payload.data.message);
        dispatch({
            type: 'SET_SNACKBAR',
            payload: {
                is_show: true,
                type: 'alert',
                msg: msg?.body
            }
        });
    }
};

export const requestNotificationPermission = async () => {
    const permission = await Notification.requestPermission();

    if (permission === "denied") {
        showNotification({notificationType: 'NOTIFICATION_PERMISSION_DENIED'});
    }
};

export const openRemedialJobAlertView = (job_id, dispatch) => {
    dispatch({
        type: 'SET_SNACKBAR_AND_REMEDIALJOBALERT',
        snackbar: {
            is_show: true,
            type: 'alert',
            msg: "You have a new remedial job."
        },
        remedialJobAlert: {
            is_show: true,
            job_id
        }
    });
};

export const openRescheduleJobAlertView = (parsedBody, dispatch) => {
    dispatch({
        type: 'SET_SNACKBAR_AND_RESCHEDULEJOBALERT',
        snackbar: {
            is_show: true,
            type: 'alert',
            msg: "You have a new reschedule job."
        },
        rescheduleJobAlert: {
            is_show: true,
            rescheduleJob_data: {
                job_id: parsedBody.job_id,
                reschedule_job_id: parsedBody.reschedule_job_id, 
                reschedule_job_start_timestamp: parsedBody.reschedule_job_start_timestamp,
                reschedule_job_end_timestamp: parsedBody.reschedule_job_end_timestamp,
            }
        }
    });
};

export const openReCallVisitAlertView = (re_call_visit_id, dispatch) => {
    dispatch({
        type: 'SET_SNACKBAR_AND_RECALLVISITALERT',
        snackbar: {
            is_show: true,
            type: 'alert',
            msg: "You have a new visit to recall."
        },
        reCallVisitAlert: {
            is_show: true,
            re_call_visit_id
        }
    });
};

/*************************************** START FIREBASE LISTENER ****************************************/
export const jobFirebaseListener = async (newValue, dispatch, pathname) => {
    const runFirebaseListener = (job_firebase_document_id) => {
        const documentId = job_firebase_document_id?.trim();
        if (!documentId) return;

        jobsRef.doc(documentId).onSnapshot(async (doc) => {
            const details = doc.data();
            if (details?.job_ftm_new_request && !["/", "/lockscreen", "/sign/in", "/sign/up/registration"].includes(pathname)) {
                openFtmRequestAlertView({
                    job_id: details.job_id, 
                    request_id: details.job_ftm_new_request
                }, dispatch);
            }
        });
    };

    if (newValue?.job_firebase_document_id) {
        await runFirebaseListener(newValue?.job_firebase_document_id);
    }else{
        const response = await GET(`v3/jobs/${newValue.job_id}/firestore-key`);
        if(response?.status === "Success"){
            const key = response?.data?.key;
            await runFirebaseListener(key);
        }
    }
};

export const userFirebaseListener = async (dispatch, pathname) => {
    const documentId = user_info?.customer_firebase_document_id?.trim();
    if (documentId && !["/", "/lockscreen", "/sign/in", "/sign/up/registration"].includes(pathname)) {
        usersRef.doc(documentId).onSnapshot(async (doc) => {
            const details = doc.data();
            if (details?.user_new_remedial_job) {
                openRemedialJobAlertView(details.user_new_remedial_job, dispatch);
            }
            if (details?.user_new_reschedule_job > 0) {
                const res = await rescheduleJob(details.user_new_reschedule_job);
                openRescheduleJobAlertView({
                    job_id: res?.data.reschedule_job_job_id,
                    reschedule_job_id: res?.data.reschedule_job_id, 
                    reschedule_job_start_timestamp: res?.data.reschedule_job_start_timestamp,
                    reschedule_job_end_timestamp: res?.data.reschedule_job_end_timestamp
                }, dispatch);
            }
        });
    }
};

export const rescheduleJob = async (reschedule_job_id) => {
    const response = await GET(`v3/reschedule-jobs/${reschedule_job_id}`);
    return response?.status === "Success" ? response : null;
}
/*************************************** END FIREBASE LISTENER ****************************************/

export const isShowChatNotifications = (job_id, message_type) => {
    PUT("customer/show/notification", {
        customer_id: user_info?.customer_id,
        job_id,
        message_type
    });
};

export const checkTermsAndConditions = async () => {
    if(user_info?.customer_id){
        const response = await GET(`customer/check/is/approved/terms/and/condition/${user_info?.customer_id}`);
        return response.status === "Success" ? response : null;
    }else{
        return null
    }
};
